export enum OrderCheckoutActivePanelEnum {
  item = 0,
  shippingOptions = 1,
  shippingRate = 2,
  paymentMethod = 3,
  payment = 4,
}
